/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ComprobarInteraccionFarmacoDto } from '../../models/comprobar-interaccion-farmaco-dto';

export interface FarmacosControllerComprobarInteraccionFarmacoPaciente$Params {
  programaUuid: string;
  farmacoUuid: string;
}

export function farmacosControllerComprobarInteraccionFarmacoPaciente(http: HttpClient, rootUrl: string, params: FarmacosControllerComprobarInteraccionFarmacoPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<ComprobarInteraccionFarmacoDto>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerComprobarInteraccionFarmacoPaciente.PATH, 'post');
  if (params) {
    rb.path('programaUuid', params.programaUuid, {});
    rb.path('farmacoUuid', params.farmacoUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ComprobarInteraccionFarmacoDto>;
    })
  );
}

farmacosControllerComprobarInteraccionFarmacoPaciente.PATH = '/api/farmacos/comprobar-interaccion-farmaco/{programaUuid}/{farmacoUuid}';
